var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.69,
    height: 30.823,
    viewBox: "0 0 28.69 30.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_132",
    "data-name": "Rect\\xE1ngulo 132",
    width: 28.69,
    height: 30.823,
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    transform: "translate(-5 -5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M45.9,0c.136.039.275.073.409.119A2.229,2.229,0,1,1,45.1.054c.06-.014.119-.036.178-.054Zm1.16,2.226A1.465,1.465,0,1,0,45.6,3.7,1.461,1.461,0,0,0,47.06,2.226",
    transform: "translate(-38.051 3.819)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M260.67,0c.113.033.227.064.34.1a2.229,2.229,0,1,1-1.093-.053A1.107,1.107,0,0,0,260.049,0Zm-1.776,2.237A1.464,1.464,0,1,0,260.359.764a1.458,1.458,0,0,0-1.464,1.473",
    transform: "translate(-239.111 3.819)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_153",
    "data-name": "Trazado 153",
    d: "M3.972,192.415H7.387c.405,0,.523.116.536.524a3.924,3.924,0,0,0,7.8.461,4.876,4.876,0,0,0,.044-.5c.017-.359.143-.486.5-.486H22.24c.318,0,.637,0,.955,0a.393.393,0,0,1,.445.441q.007,1.039,0,2.078a.39.39,0,0,1-.384.433c-.821.1-1.642.205-2.465.285-.25.024-.406.086-.475.351a3.488,3.488,0,0,1-.276.659.235.235,0,0,0,.034.3c.522.652,1.038,1.31,1.556,1.966.3.377.292.481-.055.828l-2.821,2.82c-.285.285-.424.293-.738.045-.669-.527-1.34-1.051-2-1.584a.258.258,0,0,0-.318-.034,8.032,8.032,0,0,1-.77.319.265.265,0,0,0-.2.252c-.1.854-.2,1.707-.3,2.561-.039.346-.16.461-.507.461q-2.078,0-4.156,0c-.331,0-.455-.119-.493-.451-.1-.854-.2-1.707-.294-2.561a.283.283,0,0,0-.218-.268A7.247,7.247,0,0,1,8.007,201a.272.272,0,0,0-.339.039c-.664.533-1.335,1.058-2,1.584-.3.237-.444.226-.72-.049l-2.887-2.889c-.265-.266-.276-.408-.046-.7.531-.676,1.062-1.352,1.6-2.023a.255.255,0,0,0,.036-.316,7.106,7.106,0,0,1-.31-.748.3.3,0,0,0-.284-.231c-.846-.093-1.691-.2-2.537-.294-.347-.039-.466-.157-.467-.5q0-.991,0-1.983c0-.338.14-.475.482-.475q1.72,0,3.44,0m9.718,11.4c.1-.888.212-1.748.3-2.609a.544.544,0,0,1,.4-.521,13.188,13.188,0,0,0,1.232-.509.515.515,0,0,1,.613.061c.406.333.822.653,1.235.979l.83.652,2.61-2.607c-.037-.05-.087-.12-.141-.188-.5-.631-.992-1.265-1.5-1.891a.5.5,0,0,1-.069-.572c.191-.427.373-.859.539-1.3a.479.479,0,0,1,.425-.356c.459-.05.917-.1,1.375-.158.439-.052.878-.106,1.311-.159V193.19H16.545a4.719,4.719,0,0,1-9.4.007H.83v1.446c.868.1,1.719.211,2.573.3a.569.569,0,0,1,.566.444,5.586,5.586,0,0,0,.345.887c.35.714.326.613-.158,1.23-.466.593-.933,1.186-1.371,1.742L5.4,201.859c.673-.53,1.376-1.078,2.071-1.635a.481.481,0,0,1,.551-.065c.428.189.859.372,1.3.537a.5.5,0,0,1,.37.469c.027.309.066.617.1.925.068.574.139,1.148.209,1.727Z",
    transform: "translate(2.501 -175.043)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_154",
    "data-name": "Trazado 154",
    d: "M4.952,82.506H.559c-.441,0-.555-.113-.555-.547,0-1.194.011-2.387,0-3.581a1.653,1.653,0,0,1,1.023-1.659A7.954,7.954,0,0,1,2.8,76.2a12.1,12.1,0,0,1,5.481.262,3.2,3.2,0,0,1,.857.4,1.6,1.6,0,0,1,.757,1.43c-.007,1.225,0,2.451,0,3.676,0,.41-.115.529-.522.529q-2.208,0-4.417,0m2.066-.777v-.289q0-1.253,0-2.507c0-.31.132-.476.373-.478s.389.168.391.49c0,.366,0,.732,0,1.1v1.684H9.127v-.242c0-1.042-.01-2.085,0-3.127a.983.983,0,0,0-.577-.96,2.978,2.978,0,0,0-.575-.225A11.459,11.459,0,0,0,3.2,76.912a10.28,10.28,0,0,0-1.814.472.943.943,0,0,0-.625,1c.015,1.034,0,2.069,0,3.1v.242H2.116c0-.6,0-1.191,0-1.779,0-.358-.007-.716,0-1.074a.384.384,0,0,1,.551-.382.414.414,0,0,1,.212.42c0,.851,0,1.7,0,2.554,0,.084.007.169.012.264Z",
    transform: "translate(2.546 -67.339)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_155",
    "data-name": "Trazado 155",
    d: "M219.689,82.616H215.32c-.462,0-.567-.1-.567-.556,0-1.194.012-2.387,0-3.581a1.746,1.746,0,0,1,1.021-1.668,5.793,5.793,0,0,1,1.852-.515,12.735,12.735,0,0,1,5.23.225,2.726,2.726,0,0,1,1.313.689,1.547,1.547,0,0,1,.472,1.113q.008,1.922,0,3.843c0,.319-.15.448-.509.448q-2.22,0-4.44,0m4.187-.776c0-1.14-.008-2.254,0-3.367a1,1,0,0,0-.6-.975,2.927,2.927,0,0,0-.554-.214,11.609,11.609,0,0,0-5.06-.219,8.568,8.568,0,0,0-1.553.436.923.923,0,0,0-.6.961c.016.8,0,1.607,0,2.411v.965h1.345v-.27c0-.843,0-1.687,0-2.53,0-.3.14-.471.384-.471s.378.163.378.472q0,1.265,0,2.53c0,.085,0,.17,0,.265h4.138v-.276c0-.851,0-1.7,0-2.554,0-.278.135-.431.364-.438s.385.152.4.436c0,.056,0,.111,0,.167q0,1.206,0,2.411c0,.084.007.168.012.261Z",
    transform: "translate(-198.497 -67.448)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.146586a46723e4836f88ba68eea02ff4.svg";
export { ForwardRef as ReactComponent };